import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "o-grid" }
const _hoisted_2 = ["id", "name", "checked", "required", "aria-required"]
const _hoisted_3 = ["for"]
const _hoisted_4 = { class: "c-form-control-checkbox__label-text" }
const _hoisted_5 = { class: "o-grid__cell o-grid__cell--5 u-form-grid-nospace-y" }
const _hoisted_6 = ["name", "value", "min", "max", "disabled", "required", "aria-required", "data-fehlermeldung"]
const _hoisted_7 = { class: "o-grid__cell o-grid__cell--12 u-grid-no-y-gutter u-pad-b-1" }
const _hoisted_8 = {
  key: 0,
  class: "gev19__contexthelp-text o-grid__cell--no-space"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass('o-grid__cell o-grid__cell--' + _ctx.checkboxBreite + ' u-form-grid-nospace-y label-alignment')
    }, [
      _createElementVNode("input", {
        id: _ctx.sanierungsfrage?.nameCheckbox,
        name: _ctx.sanierungsfrage?.nameCheckbox,
        class: "c-form-control-checkbox__input",
        type: "checkbox",
        checked: _ctx.jahrChecked,
        required: _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt,
        "aria-required": _ctx.piniaStore.state.gebaeudedaten.sanierungsdaten.kernsanierungDurchgefuehrt,
        "aria-label": "Art der Sanierung",
        "data-fehlermeldung": "Bei durchgeführter Kernsanierung muss dieses Feld ausgewählt werden",
        "data-cy": "sanierungsFrage",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:jahrChecked', $event.target.checked)))
      }, null, 40, _hoisted_2),
      _createElementVNode("label", {
        class: "c-form-control-checkbox__label",
        for: _ctx.sanierungsfrage.nameCheckbox
      }, [
        _createVNode(_component_icon_sprite, {
          "icon-name": "icon-check-mark",
          "css-klassen": "c-form-control-checkbox__icon",
          "ist-klein": true
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.name), 1)
      ], 8, _hoisted_3),
      _createVNode(_component_validierungs_fehler, {
        "fehler-text": _ctx.fehler[_ctx.sanierungsfrage.nameCheckbox]
      }, null, 8, ["fehler-text"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass('o-grid__cell o-grid__cell--' + _ctx.infoBreite + ' u-form-grid-nospace-y label-alignment')
    }, [
      _createElementVNode("span", {
        class: "c-notice-icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showables.showHelp = !_ctx.showables.showHelp))
      }, [
        _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
      ])
    ], 2),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("input", {
        type: "number",
        onKeydown: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
        name: _ctx.sanierungsfrage.nameInput,
        value: _ctx.jahr,
        class: "c-form-control__input u-mar-t-0",
        "data-cy": "sanierungsJahr",
        placeholder: "JJJJ",
        min: _ctx.jahrMin,
        max: _ctx.jahrMax,
        disabled: !_ctx.jahrChecked,
        required: _ctx.jahrChecked,
        "aria-required": _ctx.jahrChecked,
        "aria-label": "Jahr der Sanierung",
        "data-fehlermeldung": _ctx.jahrFehlerText,
        onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:jahr', _ctx.inputChangeHandler($event))))
      }, null, 40, _hoisted_6),
      _createVNode(_component_validierungs_fehler, {
        "fehler-text": _ctx.fehler[_ctx.sanierungsfrage.nameInput]
      }, null, 8, ["fehler-text"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.showables.showHelp)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("p", null, _toDisplayString(_ctx.infoText), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}